module.exports = __webpack_public_path__ + "img/setting-grey.b89ecd4e.svg";